import React from 'react';
import {
  ModalOverlay,
  ModalContainer,
  ModalCloseButtonArea,
  ModalCloseButton,
  Header,
  Body,
  Footer,
  ModalItemBg,
} from './styles';
import { BdsButton, BdsIcon, BdsTypo, BdsAccordion, BdsAccordionHeader, BdsAccordionBody, BdsAccordionGroup } from 'blip-ds/dist/blip-ds-react';

interface CustomModalProps {
  open: boolean;
  modalTitle?: string;
  modalDescription?: string;
  delivered?: { title: string; description: string; };
  paids?: { title: string; description: string; };
  free?: { title: string; description: string; calculation?: string; };
  entryPoint?: { title: string; description: string };
  service?: { title: string; description: string };
  modalAlert?: string;
  modalAction: string;
  onClose: () => void;
  clickY: number;
}

export const CustomModal: React.FC<CustomModalProps> = ({
  open,
  modalTitle = 'Título Padrão',
  modalDescription,
  delivered,
  paids,
  free,
  entryPoint,
  service,
  modalAlert,
  modalAction,
  onClose,
  clickY,
}) => {

  if (!open) {
    return null;
  }

  return (
    <ModalOverlay onClick={onClose} $positionY={clickY}>
      <ModalContainer
        onClick={(e) => e.stopPropagation()}
        $positionY={clickY}
      >
        <Header>
          <ModalCloseButtonArea>
            <ModalCloseButton>
              <BdsIcon onClick={onClose} theme="outline" name="close" size='medium' />
            </ModalCloseButton>
          </ModalCloseButtonArea>
        </Header>
        <Body>
          <BdsTypo variant="fs-20" bold="bold" margin={false}>
            {modalTitle}
          </BdsTypo>
          {delivered && paids && free && entryPoint && service && (
            <>
              <BdsAccordionGroup collapse="single">
                <BdsAccordion startOpen={true}>
                  <BdsAccordionHeader accordionTitle={delivered.title} icon='attention' />
                  <BdsAccordionBody>
                    <ModalItemBg>
                      <BdsTypo variant="fs-14" bold="regular">
                        <div dangerouslySetInnerHTML={{ __html: delivered.description }} />
                      </BdsTypo>
                    </ModalItemBg>
                  </BdsAccordionBody>
                </BdsAccordion>
                <BdsAccordion>
                  <BdsAccordionHeader accordionTitle={paids.title} icon='attention' />
                  <BdsAccordionBody>
                    <ModalItemBg>
                      <BdsTypo variant="fs-14" bold="regular">
                        <div dangerouslySetInnerHTML={{ __html: paids.description }} />
                      </BdsTypo>
                    </ModalItemBg>
                  </BdsAccordionBody>
                </BdsAccordion>
                <BdsAccordion>
                  <BdsAccordionHeader accordionTitle={free.title} icon='attention' />
                  <BdsAccordionBody>
                    <ModalItemBg>
                      <BdsTypo variant="fs-14" bold="regular">
                        <div dangerouslySetInnerHTML={{ __html: free.description + free.calculation }} />
                      </BdsTypo>
                    </ModalItemBg>
                  </BdsAccordionBody>
                </BdsAccordion>
                <BdsAccordion>
                  <BdsAccordionHeader accordionTitle={entryPoint.title} icon='attention' />
                  <BdsAccordionBody>
                    <ModalItemBg>
                      <BdsTypo variant="fs-14" bold="regular">
                        <div dangerouslySetInnerHTML={{ __html: entryPoint.description }} />
                      </BdsTypo>
                    </ModalItemBg>
                  </BdsAccordionBody>
                </BdsAccordion>
                <BdsAccordion>
                  <BdsAccordionHeader accordionTitle={service.title} icon='attention' />
                  <BdsAccordionBody>
                    <ModalItemBg>
                      <BdsTypo variant="fs-14" bold="regular">
                        <div dangerouslySetInnerHTML={{ __html: service.description }} />
                      </BdsTypo>
                    </ModalItemBg>
                  </BdsAccordionBody>
                </BdsAccordion>
              </BdsAccordionGroup>
            </>
          )}
          {modalDescription && (
            <BdsTypo variant="fs-14" bold="regular">
              <div dangerouslySetInnerHTML={{ __html: modalDescription }} />
            </BdsTypo>
          )}
          {modalAlert && (
            <BdsTypo variant="fs-14" bold="regular">
              <div dangerouslySetInnerHTML={{ __html: modalAlert }} />
            </BdsTypo>
          )}
        </Body>
        <Footer>
          <BdsButton onClick={onClose}>
            {modalAction}
          </BdsButton>
        </Footer>
      </ModalContainer>
    </ModalOverlay>
  );
};